import React from "react";
import { Link } from "react-router-dom";
import logo from '../../assets/logo.png'


const Sidebar = () => {
    return (
        <div className="w-64 bg-white border-r border-gray-200 text-gray-800 p-6 flex flex-col shadow-sm">
            <h2 className="mb-6 mx-auto"><img src={logo} className="h-14" alt="Admin Panel" /></h2>
            <ul className="space-y-4">
                <li><Link to="/dashboard" className="py-3 px-4 bg-gray-100 rounded-lg cursor-pointer block hover:bg-gray-200 transition text-gray-700">Dashboard</Link></li>
                <li><Link to="/user" className="py-3 px-4 bg-gray-100 rounded-lg cursor-pointer block hover:bg-gray-200 transition text-gray-700">Users</Link></li>
                {/* <li><Link to="/announcement" className="py-3 px-4 bg-gray-100 rounded-lg cursor-pointer block hover:bg-gray-200 transition text-gray-700">Announcement</Link></li> */}
                {/* <li><Link to="/weekly-leaderboard" className="py-3 px-4 bg-gray-100 rounded-lg cursor-pointer block hover:bg-gray-200 transition text-gray-700">Weekly Leaderboard</Link></li>
                <li><Link to="/pioneer-list" className="py-3 px-4 bg-gray-100 rounded-lg cursor-pointer block hover:bg-gray-200 transition text-gray-700">Pioneer List</Link></li>*/}
                <li><Link to="/history" className="py-3 px-4 bg-gray-100 rounded-lg cursor-pointer block hover:bg-gray-200 transition text-gray-700">History</Link></li>
                <li><Link to="/notifications" className="py-3 px-4 bg-gray-100 rounded-lg cursor-pointer block hover:bg-gray-200 transition text-gray-700">Notification</Link></li>
                <li><Link to="/settings" className="py-3 px-4 bg-gray-100 rounded-lg cursor-pointer block hover:bg-gray-200 transition text-gray-700">Settings</Link></li>
            </ul>
        </div>
    );
};


export default Sidebar;